import PaymentDetailsModal from "../pages/payments/components/PaymentDetailsModal";
import styles from "../styles/customerStyles.module.css";

export const getChipProps = (params) => {
  if (params.value === "Success" || "SUCCESS") {
    return (
      <PaymentDetailsModal value={params.value} products={params.products} transaction={params?.transaction} />
    );
  }
  if (params.value === "Reject") {
    return (
      <PaymentDetailsModal value={params.value} products={params.products}/>
    );
  }
  if (params.value === "Pending" || "PENDING") {
    return (
      <PaymentDetailsModal value={params.value} products={params.products}/>
    );
  }
  if (params.value === "Failed") {
    return (
      <div
        style={{
          background: "#FFF0F0",
          // width:"50%"
        }}
        className={styles.fulfillment}
      >
        {params.value}
      </div>
    );
  }

  if (params.value === "In Stock") {
    return (
      <div
        style={{
          background: "#D4FFD3",
          // width:"50%"
        }}
        className={styles.fulfillment}
      >
        {params.value}
      </div>
    );
  }
  if (params.value === "Stock out") {
    return (
      <div
        style={{
          background: "#FFF0F0",
          // width:"50%"
        }}
        className={styles.fulfillment}
      >
        {params.value}
      </div>
    );
  } else if (params.value === "Delivered") {
    return (
      <div
        style={{
          background: "#D4FFD3",
          // width:"50%"
        }}
        className={styles.fulfillment}
      >
        {params.value}
      </div>
    );
  } else if (params.value === "Unshipped") {
    return (
      <div
        style={{
          background: "#FFF0F0",
          // width:"50%"
        }}
        className={styles.fulfillment}
      >
        {params.value}
      </div>
    );
  } else if (params.value === "Completed") {
    return (
      <div
        style={{
          background: "#D4FFD3",
          // width:"50%"
        }}
        className={styles.fulfillment}
      >
        {params.value}
      </div>
    );
  } else if (params.value === "Picked up") {
    return (
      <div
        style={{
          background: "#E9DAFF",
          // width:"50%"
        }}
        className={styles.fulfillment}
      >
        {params.value}
      </div>
    );
  } else {
    return (
      <div
        style={{
          background: "#FEFFCF",
          // width:"50%"
        }}
        className={styles.fulfillment}
      >
        {params.value}
      </div>
    );
  }
};
